(function ($) {
  let map;
  let currentInfoWindow = null; // To keep track of the currently open InfoWindow

  async function initMap() {
    const { Map } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

    if (bmtgMapData && bmtgMapData.locations && bmtgMapData.locations.length > 0) {
      const bounds = new google.maps.LatLngBounds();

      map = new Map(document.getElementById('mice-map'), {
        zoom: 6,
        center: { lat: 0, lng: 0 },
        mapId: 'MICE_MAP_ID',
      });

      bmtgMapData.locations.forEach((location) => {
        const position = {
          lat: parseFloat(location.lat),
          lng: parseFloat(location.lng),
        };

        const marker = new AdvancedMarkerElement({
          map,
          position,
          title: location.title,
        });

        bounds.extend(position);

        const contentString = `
            <div class="custom-info-window">
              <div class="info-window-image" style="background-image: url('${location.image_url}');">
                <div class="info-window-close"></div>
              </div>
              <div class="info-window-content">
                <h3>${location.title}</h3>
                <div class="info-row">
                  ${bmtgMapData.categoryIcon}
                  <span>${location.categories}</span>
                  ${bmtgMapData.capacityIcon}
                  <span>${location.capacity}</span>
                </div>
                <p>${location.excerpt}</p>
                <a href="${location.link}">${bmtgMapData.learnMoreText}</a>
              </div>
            </div>
          `;

        const infoWindow = new google.maps.InfoWindow({
          content: contentString,
          maxWidth: 300,
        });

        marker.addListener('click', () => {
          // Close the currently open InfoWindow (if any)
          if (currentInfoWindow) {
            currentInfoWindow.close();
          }

          // Open the new InfoWindow
          infoWindow.open(map, marker);

          // Set the current InfoWindow to the newly opened one
          currentInfoWindow = infoWindow;

          // Add click event listener to close button after InfoWindow is opened
          google.maps.event.addListenerOnce(infoWindow, 'domready', () => {
            document.querySelector('.info-window-close').addEventListener('click', () => {
              infoWindow.close();
              currentInfoWindow = null; // Reset currentInfoWindow when closed
            });
          });
        });
      });

      map.fitBounds(bounds);

      google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
        if (this.getZoom() > 15) {
          this.setZoom(15);
        }
      });
    } else {
      console.error('No locations found in bmtgMapData');
    }
  }

  initMap();
}(jQuery));
